/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Center_RightInputs */



/**
* | output |
* | --- |
* | "Position Events to the center right of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Center_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_center_right = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Center_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner les evenements au centre droit de la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionieren Sie die Ereignisse rechts in der Mitte des Videos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posiziona gli eventi al centro a destra del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разместите события в центре справа от видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colocar eventos en el centro a la derecha del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件定位在视频右侧中间位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをビデオの中央右に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो के केंद्र के दाईं ओर घटनाओं की स्थिति निर्धारित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posicione os eventos no centro à direita do vídeo.")
	return /** @type {LocalizedString} */ ("Position Events to the center right of the video")
});